import {FC, useMemo} from "react";
import {CreateResultNode, CreateResultSummary} from "../../view-model";
import {summarizeResult} from "../../helpers";
import {CreateResultTreeView, SummaryCard} from "../common";
import {ResultsStepNodeLabel} from "./ResultsStepNodeLabel";
import "../common/BuilderStep.scss";

export interface ResultsStepProps {
  result: CreateResultNode;
}

/**
 * The {@link ResultsStep} accepts a {@link CreatePlanNode} representing the hierarchy to create.
 *
 * Currently, it simply renders a table with the name and status of the node faking the status;
 * however, it should take the hierarchy as input and invoke the AppSync mutation to create
 * the hierarchy, displaying the results in the table.
 *
 * @param node
 * @constructor
 */
export const ResultsStep: FC<ResultsStepProps> = ({result}) => {
  const summary = useMemo<CreateResultSummary>(
    () => summarizeResult(result),
    [result]
  );

  return (
    <section
      data-testid={"results-step"}
      className={"hierarchy-builder-step results-step"}>
      <section data-testid={"summary-section"} className={"summary-section"}>
        <SummaryCard
          baseKey={"create-operational-hierarchy.result-summary.created"}
          count={summary.created.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.result-summary.operational"}
          count={summary.operational.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.result-summary.failed"}
          count={summary.failed.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.result-summary.skipped"}
          count={summary.skipped.length}
        />
      </section>
      <section
        data-testid={"hierarchy-section"}
        className={"hierarchy-section"}>
        <CreateResultTreeView result={result} label={ResultsStepNodeLabel} />
      </section>
    </section>
  );
};
